<template>
    <div id="birthday">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <div class="content">
            <div class="container">
                <h2>請填寫生日</h2>
                <img src="../assets/birth.svg" alt="" class="icon">
                <p>為維護您的權益，請於下方欄位填入生日：</p>
                <div class="inputControl">
                    <BirthdayChange :dateTimeProps="birthdayAll" :key="reloadYearChangeKey"
                                    @getDateTime="getBirthdayAll" ref="yearRef" nickName="loginBirthday"/>
                </div>
                <p class="center">此為登入時必要資料使用，請務必確認其正確性。</p>
            </div>
        </div>
        <div class="anotherBtn center">
            <button class="btn confirm" @click="goNext">確定</button>
        </div>
    </div>
</template>
<script setup>
    import Loading from "@/components/loading.vue";
    import {popUp} from "@/utils/popUp";
    import {onMounted, ref} from "vue";
    import {useRouter} from "vue-router";
    import Swal from "sweetalert2";
    import BirthdayChange from "@/components/birthdayChange.vue";
    import {postApi} from "@/utils/callApi";
    import apiConfig from "@/utils/apiConfig";
    import gtm from "@/utils/gtmDataLayer";

    const router = useRouter();//轉跳router
    let startCheck = false;//開始驗證
    const birthdayAll = ref({});
    const yearRef = ref();
    const reloadYearChangeKey = ref(0);
    const isLoading = ref(false);
    let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));

    //初始載入檢查登入
    const checkLogin = ()=>{
        if(jwtInfo === null){
            router.push("/");
        }
    }
    //檢查登入輸入資料
    const checkAccount = ()=>{
        if(startCheck){
            //觸發 yearChange checkForm();
            yearRef.value?.checkForm(true);
        }
    }
    //取得生日資料
    const getBirthdayAll = (data) => {
        birthdayAll.value = data;
    }
    //OTP檢核跳轉
    const goNext = ()=>{
        startCheck = true;
        checkAccount();
        let checkFlag = 0;
        let errorMsg = [];

        if (JSON.stringify(birthdayAll.value) === "{}") {
            checkFlag++;
            errorMsg.push("生日填寫錯誤");
        }
        if (birthdayAll.value.year === "" ||birthdayAll.value.year == null
            || birthdayAll.value.month === "" || birthdayAll.value.month == null
            || birthdayAll.value.date === "" || birthdayAll.value.date == null) {
            checkFlag++;
            errorMsg.push("生日填寫錯誤");
        }

        if(checkFlag === 0){
            isLoading.value = true;
            let data = {
                updateSource:"傷害險",
                birthday:birthdayAll.value.year+'-'+birthdayAll.value.month+'-'+birthdayAll.value.date,
            }
            postApi(apiConfig.updateMember, jwtInfo.token, null, null, data)
                .then((response) => {
                    const updateMember = response.data;
                    if (updateMember.code === 200) {
                        router.push("/detail");
                    } else {
                        Swal.fire({
                            title: "填寫資料錯誤",
                            confirmButtonText: "確定",
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>您填入的資料有誤，請確認後重新輸入。</p>',
                        });
                        isLoading.value = false;
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "資料錯誤",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>檢查資料連線錯誤</p>'
                    });
                    isLoading.value = false;
            });

        }else{
            Swal.fire({
                title: "填寫資料錯誤",
                confirmButtonText: "確定",
                showCloseButton: true,
                html: '<img src="error.svg"><p>'+ errorMsg + '</p>',
            })
            isLoading.value = false;
        }
    }
    onMounted(()=>{
        gtm.pageViewEvent();
        popUp();//公告系統
        checkLogin();
    });
</script>
<style lang="scss">
#birthday {
    text-align: center;
    .content {
        p {
            margin: 5px 0;
            font-size:16px;
        }
        .icon {
            display: inline-block;
            margin: 30px auto;
        }
        .inputTitle{text-align: left}

        .inputControl {
            margin: 0 auto 30px;
            width: 75%;
        }
        .inputStyle{text-align: left}

        .link {
            display: inline-block;
            margin: 10px 0;
        }
      @media screen and (max-width: $small){
        .inputControl{
          width:100%;
        }
        .anotherBtn {
          margin: 30px 0 20px;
        }
      }
    }
    .anotherBtn {
        margin: 30px 0 50px;
    }
}


</style>
